export default __webpack_public_path__ + "static/media/appleWatch.06ae15ae.svg";